import styled from "styled-components";

export const Wrapper = styled("main")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  flex: "1 0 auto",
}));

export const MainContent = styled("div")(({ theme, $flush }) => ({
  backgroundColor: "rgb(245, 247, 250)",
  paddingTop: $flush ? 0 : 50,
  paddingBottom: $flush ? 0 : 50,
  [theme.down("md")]: {
    paddingTop: $flush ? 0 : 30,
    paddingBottom: $flush ? 0 : 30,
  },
  [theme.down("sm")]: {
    paddingTop: $flush ? 0 : 20,
    paddingBottom: $flush ? 0 : 20,
  },
}));
